import { configFile } from "@/config";

import { InstagramIcon, TwitterIcon, WebsiteIcon } from "@/img/icons";
import { Box, Flex, Text, Link as ChakraLink, useMediaQuery } from "@chakra-ui/react";
import useTranslation from "next-translate/useTranslation";
import Image from "next/image";
import Link from "next/link";

export default function AuthorCard({ props }: any) {
  const { t } = useTranslation("common")

  return (<Flex
    flexDir="column"
    width="100%"
    textAlign="center"
    boxShadow="0px 1px 3px rgba(0, 0, 0, 0.1), 0px 1px 2px rgba(0, 0, 0, 0.06)"
    borderRadius="8px"
    overflow="hidden"
    bgColor="#FFF"
  >
    <Box
      height="12px"
      bgColor={configFile.primaryAccentColor}
      width="100%"
    ></Box>
    <Text
      fontWeight="700"
      fontSize="18px"
      textAlign="start"
      width="85%"
      m="23px auto"
    >
      {t("article.author.title")}:
    </Text>
    <Flex
      bgColor="#FFF"
      alignItems="center"
      justifyContent="flex-start"
      gap="24px"
      width="85%"
      mx="auto"
    >
      <ChakraLink prefetch={false}
        as={Link}
        href={`perfil/${props.post.data[0].attributes.author.data.attributes.url}`}
      >
        <Image
          placeholder={"blur"}
          blurDataURL={'/images/logo_banner.png'}
          sizes={'150px'}
          width={122}
          height={122}
          style={{
            borderRadius: "10px",
            objectFit: "cover",
            width: "122px",
            height: "122px",
          }}
          alt={
            props.post.data[0].attributes.author.data.attributes
              .name
          }
          src={
            props.post.data[0].attributes.author.data.attributes.img
              .data.attributes.url
          }
        />
      </ChakraLink>
      <Flex
        flexDirection="column"
        alignItems="flex-start"
        width="calc(85% - 122px)"
      >
        <Box
          bgColor="gray.100"
          borderRadius="4px"
          padding="2px"
          mb="16px"
        >
          <Text
            fontWeight="700"
            fontSize="10px"
            lineHeight="16px"
            color="gray.600"
          >
            {props.authorArticlesTotal}{" "}
            {t("article.author.articlesPublished")}
          </Text>
        </Box>
        <ChakraLink prefetch={false}
          as={Link}
          fontWeight="700"
          color="gray.800"
          fontSize="16px"
          lineHeight="24px"
          _hover={{
            textDecor: "none",
            color: configFile.primaryAccentColor,
          }}
          href={`perfil/${props.post.data[0].attributes.author.data.attributes.url}`}
        >
          {
            props.post.data[0].attributes.author.data.attributes
              .name
          }
        </ChakraLink>
        <Text
          fontSize="14px"
          color="gray.600"
          lineHeight="20px"
          fontWeight="400"
          mt="4px"
        >
          {
            props.post.data[0].attributes.author.data.attributes
              .jobTitle
          }
        </Text>
        <Flex
          columnGap="12px"
          justifyContent="center"
          mt="16px"
          flexDirection="row-reverse"
        >
          {
            Boolean(props.post.data[0].attributes.author.data.attributes.instagram) &&
            <ChakraLink 
              aria-label="Instagram"
              prefetch={false}
              as={Link}
              target="_blank"
              display="flex"
              justifyContent="center"
              alignItems="center"
              href={props.post.data[0].attributes.author.data.attributes.instagram}
            >
              <InstagramIcon
                color={'gray.500'}
                boxSize={'1.5rem'}
                _hover={{ color: 'gray.600' }}
              />
            </ChakraLink>
          }
          {
            Boolean(props.post.data[0].attributes.author.data.attributes.twitter) &&
            <ChakraLink 
              aria-label="Twitter"
              prefetch={false}
              target="_blank"
              display="flex"
              justifyContent="center"
              alignItems="center"
              as={Link}
              href={props.post.data[0].attributes.author.data.attributes.twitter}
            >
              <TwitterIcon
                color={'gray.500'}
                boxSize={'1.5rem'}
                _hover={{ color: 'gray.600' }}

              />
            </ChakraLink>
          }
          {
            Boolean(props.post.data[0].attributes.author.data.attributes.website) &&
            <ChakraLink
              aria-label="Website" 
              prefetch={false}
              target="_blank"
              display="flex"
              justifyContent="center"
              alignItems="center"
              as={Link}
              href={props.post.data[0].attributes.author.data.attributes.website}
            >
              <WebsiteIcon
                color={'gray.500'}
                boxSize={'1.5rem'}
                _hover={{ color: 'gray.600' }}
              />
            </ChakraLink>
          }
        </Flex>
      </Flex>
    </Flex>
    <Flex
      width="100%"
      alignItems="center"
      justifyContent="center"
      my="32px"
    >
      <Text
        width="85%"
        fontWeight={400}
        color="gray.600"
        textAlign="start"
        lineHeight="20px"
        fontSize="14px"
      >
        {
          props.post.data[0].attributes.author.data.attributes
            .description
        }
      </Text>
    </Flex>
  </Flex>);
}